import { render } from "./machining.vue?vue&type=template&id=064acbe7&scoped=true"
import script from "./machining.vue?vue&type=script&lang=js"
export * from "./machining.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-064acbe7"

export default script